<template>
  <div>
    <v-dialog v-model="isShowDialog" persistent scrollable width="80%">
      <!-- 商品一覧に表示するカード（ここから） -->
      <template v-slot:activator="{ on, attrs }">
        <v-card class="mx-auto" max-width="500px" height="100%" v-bind="attrs" v-on="on">
          <v-card-title>
            <!-- <v-img
              :src="`data:image/png;base64, ${product.thumbnailBase64}`"
              height="auto"
              max-width="100%"
            ></v-img> -->
            <v-layout justify-center>
              <v-img :src="`${product.thumbnailUrl}`" height="auto" max-width="100%"></v-img>
            </v-layout>
          </v-card-title>
          <v-card-text class="product-detail-card-text">
            <p class="text-caption" style="white-space: pre-line">{{ productSummary }}</p>
          </v-card-text>
        </v-card>
      </template>
      <!-- 商品一覧に表示するカード（ここまで） -->
      <!-- 商品一覧のカードをクリックした際に表示するダイアログ（ここから） -->
      <v-card>
        <v-card-title class="text-h5"> {{ product.nameJa }} </v-card-title>
        <v-card-text>
          <v-container fluid fill-height>
            <v-row>
              <v-col cols="12" lg="7" xl="8">
                <v-carousel>
                  <!-- <v-carousel-item
                    v-for="(image, i) in product.imagesBase64"
                    :key="i"
                    :src="`data:image/png;base64, ${image}`"
                  > -->
                  <v-carousel-item v-for="(url, i) in product.imageUrls" :key="i" :src="`${url}`">
                  </v-carousel-item>
                </v-carousel>
              </v-col>
              <v-col cols="12" lg="5" xl="4">
                <v-card height="100%">
                  <v-card-text>
                    <p class="text-body-2" style="white-space: pre-line">{{ productDetail }}</p>
                  </v-card-text>
                  <v-card-text class="my-0 py-0">
                    <v-text-field
                      type="number"
                      id="quantity"
                      name="quantity"
                      v-model="quantity"
                      label="数量"
                      required
                      max="999"
                      min="1"
                      class="ml-auto quantity-textbox"
                    ></v-text-field>
                  </v-card-text>
                  <v-divider class="mt-0"></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="closeDialog" class="mx-2">
                      キャンセル
                    </v-btn>
                    <v-btn
                      v-bind:disabled="!isSubmit"
                      depressed
                      color="primary"
                      @click="addProductInCart"
                      class="mx-2"
                      >カートに追加
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 商品一覧のカードをクリックした際に表示するダイアログ（ここまで） -->
    </v-dialog>
    <!-- 画面遷移ダイアログ（ここから） -->
    <v-dialog v-model="isShowTransferDialog" persistent min-width="350px" max-width="400px"
      ><v-card>
        <v-card-title class="ma-5 justify-center text-subtitle-2">
          商品をカートに追加しました</v-card-title
        >
        <v-card-actions>
          <v-container fluid>
            <v-row justify="center">
              <v-col cols="12" sm="6" align="center">
                <v-btn
                  depressed
                  large
                  color="secondary"
                  @click.stop="closeTransferDialog"
                  class="mx-2"
                >
                  お買い物を続ける
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" align="center">
                <router-link to="/cart" custom v-slot="{ navigate }">
                  <v-btn depressed large color="primary" @click.stop="navigate" class="mx-2">
                    カート画面へ進む
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 画面遷移（ここまで） -->
  </div>
</template>

<script>
import validations from 'utils/validations';

export default {
  computed: {
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      let result = true;
      result &= this.errorQuantity === null;
      return result;
    },
    /**
     * 商品詳細情報を返す
     */
    /**
     * 商品詳細を取得する
     */
    productDetail: {
      cache: false,
      get() {
        return this.$store.getters['product/productDetail'](this.product.id);
      },
    },
    /**
     * 商品概要を取得する
     */
    productSummary: {
      cache: false,
      get() {
        return this.$store.getters['product/productSummary'](this.product.id);
      },
    },
  },
  data() {
    return {
      isShowDialog: false,
      isShowTransferDialog: false,
      quantity: 1,
      errorQuantity: null,
    };
  },
  methods: {
    /**
     * 画面遷移ダイアログを閉じる
     */
    closeTransferDialog: function () {
      // ダイアログを非表示にする
      this.isShowTransferDialog = false;
    },
    /**
     * 商品詳細ダイアログを閉じる
     */
    closeDialog: function () {
      // ダイアログを非表示にする
      this.isShowDialog = false;
      // 入力内容を初期化する
      this.resetInputForm();
    },
    /**
     * カートに商品を追加する
     */
    addProductInCart: function () {
      const quantity = parseInt(this.quantity);
      if (isNaN(quantity)) return;
      // カートに商品を追加する
      this.$store.commit('shoppingOrder/addProductInCart', {
        product: this.product,
        quantity: quantity,
      });
      // 商品詳細ダイアログを非表示にする
      this.isShowDialog = false;
      // 画面遷移ダイアログを表示する
      this.isShowTransferDialog = true;
    },
    /**
     * 入力値を初期化する
     */
    resetInputForm: function () {
      this.quantity = 1;
      this.errorQuantity = null;
    },
  },
  props: {
    product: {
      type: Object,
      default: null,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
@import 'stylesheets/input-form.scss';

.product-detail-card {
  &-actions {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
  &-text {
    height: 200px;
  }
}

.quantity-textbox {
  width: 20%;
  min-width: 100px;
}
</style>
